<template>
  <div class="card">
    <div class="full-control">
      <div class="list">
        <md-list class="p-0" :md-expand-single="expandSingle">
          <md-list-item md-expand :md-expanded.sync="expandMapSelect?expandMapSelect:expandNews">
            <md-toolbar :class="`md-${colorBadge}`" :style="expandMapSelect?'box-shadow:10px 10px 10px #068bea':''">
              <i :class="`badge badge-${colorBadge} help`">
                <md-icon v-if="icon" style="color: white">{{ icon }}</md-icon>
                <img
                  v-else
                  :src="require(`@/assets/icons/${badge}.png`)"
                  alt="ireal badge"
                />
              </i>

              <Message
                v-if="message"
                class="md-list-item-text text-uppercase"
                :msg="`${tx(title)}`"
              ></Message>
              <span v-else class="md-list-item-text text-uppercase">{{
                title ? tx(title) : ""
              }}</span>
              <slot name="helper"></slot>
            </md-toolbar>
            <md-list class="p-0" slot="md-expand">
              <slot></slot>
            </md-list>
          </md-list-item>
        </md-list>
      </div>
    </div>
  </div>
</template>

<script>
// import toggleWidget from "ireal-vue/widgets/ToggleWidget.vue";
// import badgeWidget from "ireal-vue/widgets/BadgeWidget.vue";
// import Collapse from "vue-material-kit-pro/src/components/Collapse.vue";
import Message from "ireal-vue/components/MessageComponent.vue";

export default {
  name: "collapsible-widget",
  icons: {
    iconfont: "md",
  },
  props: [
    "collapsed",
    "uuid",
    "title",
    "badge",
    "colorBadge",
    "icon",
    "message",
    "expandMapSelect"
  ],
  components: { Message },
  data() {
    return {
      expandNews: true,
      expandSingle: true,
    };
  },
};
</script>
<style scoped>
.button {
  margin-top: 2%;
  margin-right: 2%;
}
.md-card {
  margin-top: 5% !important;
  margin-bottom: 5% !important;
}
.md-list-item-text {
  white-space: normal !important;
}
</style>
